import { invoicingEntityApi } from '@atheneum/api'
import { extendObservable, action, computed } from 'mobx'

class InvoicingStore {
  constructor (staticData, growlStore) {
    extendObservable(this, {
      loading: false,
      error: null,
      staticData,
      growlStore,
      parentAccountId: null,
      invoicingEntity: null,
      timezone: computed(() => {
        if (!this.invoicingEntity) return ''
        const timezoneId = this.invoicingEntity.address.timezoneId
        return this.staticData.names.timezones[timezoneId]
      })
    })
  }

  deleteInvoicingEntity = action(invoiceId => {
    return invoicingEntityApi.deleteInvoicingEntity(invoiceId).catch(err => {
      this.error = err
      this.growlStore.showError(err)

      throw err
    })
  })

  getInvoicingEntity = action(invoicingEntityId => {
    this.loading = true
    return invoicingEntityApi.get(invoicingEntityId).then(res => {
      this.invoicingEntity = res
      this.loading = false
    })
  })
}

export default InvoicingStore
